import React, { ReactNode, useEffect, useState } from "react";
import { Carousel } from "../../Layouts/Carousel/Carousel";
import { IconButton } from "@mui/material";
import { DeleteForever, ImageOutlined } from "@mui/icons-material";
import { useForm } from "react-hook-form";
import { FormFieldErrorMessage } from "../FormFieldErrorMessage/FormFieldErrorMessage";
import { formatTheme } from "../../../config/MuiColorThemes";
import { createTheme } from "@mui/material/styles";

interface AddDocumentsWithPreviewProps {
  maxSizeInMB?: number;
  showPreview?: boolean;
  onChange?: (e: File[]) => void;
  children?: ReactNode;
  selectedDocs?: File[];
  currentDoc?: string[];
}

export function AddDocumentsWithPreview({
  onChange = () => {},
  showPreview = true,
  children = <></>,
  maxSizeInMB = 10,
  selectedDocs = [],
  currentDoc = [],
}: AddDocumentsWithPreviewProps) {
  const [allSelectedImages, setAllSelectedImages] =
    useState<File[]>(selectedDocs);
  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();
  function addToPreview(fileForPreview: File) {
    setAllSelectedImages((prev) => {
      if (fileForPreview) {
        return [...prev, fileForPreview];
      }
      return [...prev];
    });
  }
  useEffect(() => {
    // const debounce = setTimeout(() => {
    onChange(allSelectedImages);
    // }, 800);
    // return () => {
    //   clearTimeout(debounce);
    // };
  }, [allSelectedImages]);
  const dynamicPalette = formatTheme();
  const dynamicTheme = createTheme(dynamicPalette);
  const [isHovered, setIsHovered] = useState(false);
  return (
    <div>
      <div>
        <label>
          <div
            className="flex justify-center border border-gray-700 rounded-md p-1 w-1/2 text-center bg-gray-100 cursor-pointer"
            style={{
              color: isHovered
                ? dynamicTheme?.palette["primary"]?.main
                : "inherit",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <svg
              className="w-8 h-8"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
            </svg>
            {/* <span className="text-red-500">Browse</span> */}
          </div>
          <input
            {...register("file", {
              // required: {
              //   value: !allSelectedImages.length,
              //   message: "Please provide at least 1 Document",
              // },
            })}
            required={false}
            type={"file"}
            // style={{ display: "none" }}
            accept={"image/*,.pdf"}
            className={" h-12 w-1/2  hidden "}
            onChange={async (e) => {
              if (e.target.files && e.target.files.length) {
                if (e.target.files[0]?.size > maxSizeInMB * 1024 * 1024) {
                  setError(
                    "file",
                    {
                      type: "size",
                      message:
                        "File size should not be greater than" +
                        maxSizeInMB +
                        "MB",
                    },
                    {
                      shouldFocus: true,
                    }
                  );
                } else {
                  clearErrors("file");
                  addToPreview(e.target.files[0]);
                }
              }
            }}
          />
        </label>
      </div>
      <FormFieldErrorMessage>{errors?.file?.message}</FormFieldErrorMessage>
      {showPreview && (
        <>
          {/*<h2>Selected Images</h2>*/}
          <div className={"w-full"}>
            {allSelectedImages.length > 0 && (
              <Carousel
                direction={"horizontal"}
                onSlideItemClick={() => {}}
                carouselItems={allSelectedImages.map((el, index) => {
                  if (el.type.includes("pdf")) {
                    return (
                      <div className={"relative box-border m-2"} key={index}>
                        <IconButton
                          className={"h-8 w-8"}
                          style={{
                            position: "absolute",
                            top: 0,
                            right: -30,
                            zIndex: 10,
                          }}
                          onClick={() => {
                            setAllSelectedImages((prev) => {
                              prev.splice(index, 1);
                              return [...prev];
                            });
                          }}
                        >
                          <DeleteForever color={"error"} />
                        </IconButton>
                        <div
                          className={
                            "bg-red-200 h-full w-full box-border p-8 rounded-lg text-red-800"
                          }
                        >
                          PDF File
                        </div>
                      </div>
                    );
                  }
                  return (
                    <div
                      className={
                        "hover:drop-shadow-md box-border m-2 cursor-pointer inline-block"
                      }
                      key={index}
                    >
                      <div
                        className={"relative rounded-lg bg-white inline-block"}
                      >
                        <IconButton
                          className={"h-8 w-8"}
                          style={{
                            position: "absolute",
                            top: 0,
                            right: -30,
                            zIndex: 10,
                          }}
                          onClick={() => {
                            setAllSelectedImages((prev) => {
                              prev.splice(index, 1);
                              return [...prev];
                            });
                          }}
                        >
                          <DeleteForever color={"error"} />
                        </IconButton>
                        <img
                          className={"h-28 w-auto object-contain p-4"}
                          src={URL.createObjectURL(el)}
                          alt={"File uploaded preview"}
                        />
                      </div>
                    </div>
                  );
                })}
              />
            )}
          </div>
        </>
      )}
      {children}
    </div>
  );
}
